var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading-bar",style:(_vm.getStyle)},[_c('div',{staticClass:"percentage",class:_vm.getPercentageClass,on:{"dragover":_vm.onClickDrag}})])])}
var staticRenderFns = []

export { render, staticRenderFns }